import { useState, useEffect } from 'react';
import { useEventDesignThemingProvider } from '@shared/core/website/theming';
import { Category } from '@graphql/generated-base';
import { withWindow } from '@shared/utils/withWindow';

// Older webviews may have window/document but lack the Font Loading API
const getFontFaceSet = () => withWindow(global => ('fonts' in global.document ? global.document.fonts : undefined), undefined);

/**
 * Checks if the EVENT_TITLE font pack font is actually downloaded and available
 * in the browser using the Font Loading API (`document.fonts`).
 */
export const useFontPackReady = (): boolean => {
  const { eventDesign } = useEventDesignThemingProvider();
  const fontFamily = eventDesign?.fonts?.find(f => f.category === Category.EVENT_TITLE)?.font?.fontFamily;

  const [ready, setReady] = useState(() => {
    if (!fontFamily) return true;
    const fontFaceSet = getFontFaceSet();
    return fontFaceSet ? fontFaceSet.check(`16px "${fontFamily}"`) : true;
  });

  useEffect(() => {
    if (ready || !fontFamily) return;
    const fontFaceSet = getFontFaceSet();
    if (!fontFaceSet) {
      setReady(true);
      return;
    }
    fontFaceSet.load(`16px "${fontFamily}"`).then(() => setReady(true));
  }, [fontFamily, ready]);

  return ready;
};
